import { sortBy } from 'lodash';

export const dateFormat = 'YYYY-MM-DD';
export const dateFormatShort = 'DD/MM/YY';
export const YYYY_MM_DD_HH_SS = 'yyyy-MM-dd-HH-ss';

export function sortCollectionByField(collection, fieldName) {
  return sortBy(collection, [fieldName]);
}
